import { TFunction } from 'i18next'

import { OnboardingWorkMode } from '../../../../../enums/onboardingWorkMode'
import { SingleCardSelectOption } from '../../SingleCardSelect'

export const getWorkStyleOptions = (t: TFunction): SingleCardSelectOption[] => [
  {
    id: OnboardingWorkMode.Alone,
    label: t('onboarding.steps.work_style.alone'),
  },
  {
    id: OnboardingWorkMode.HaveEmployees,
    label: t('onboarding.steps.work_style.has_employees'),
  },
  {
    id: OnboardingWorkMode.WithContractors,
    label: t('onboarding.steps.work_style.works_with_freelancers'),
  },
]
